import type {
    LocateAccount,
    LocatePlatformDiscoveryRequest,
    LocatePlatformDiscoveryResponse,
} from '@thinkalpha/ui-types/contracts/locates/platforms';
import { createInstance } from 'src/api';
import { appConfig } from 'src/lib/config';

const axios = createInstance({ baseURL: appConfig.locatesApi });

export async function getLocatesAccounts(accountIds?: string[]): Promise<LocateAccount[]> {
    const { data } = await axios.post<LocatePlatformDiscoveryResponse>('/platforms/discover', {
        accountIds: accountIds,
    } satisfies LocatePlatformDiscoveryRequest);
    return data.accounts as LocateAccount[];
}
